module.exports = __webpack_public_path__ + "static/media/4-2.46131893.png";